import { DeleteParams } from '@anm/components/stream/StreamItem';
import { uploadsActions, uploadsSelectors } from '@anm/store/modules/uploads';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LiveStreamKind } from 'types/stream';

import { hostedVideoSelectors } from '../../../../store/modules/hostedVideo';
import { streamActions, streamSelectors } from '../../../../store/modules/stream';
import { videoFolderActions, videoFolderSelectors } from '../../../../store/modules/videoFolder';

const useDeleteStream = (kind: LiveStreamKind, projectId?: string, uploadId?: string, hasWebinar?: boolean) => {
  const dispatch = useDispatch();
  const isDeleteProjectPending = useSelector(videoFolderSelectors.selectDeleteProjectIsPending);
  const isDeleteVideoPending = useSelector(hostedVideoSelectors.selectDeleteVideoPending);
  const isDeleteStreamPending = useSelector(streamSelectors.selectDeleteStreamIsPending);

  const isDeletePending = isDeleteProjectPending || isDeleteVideoPending || isDeleteStreamPending;

  const uploadProjects = useSelector(uploadsSelectors.selectUploadProjects).data?.projects;

  const handleDeleteStream = useCallback(
    ({ canDeleteFile, streamId, destinationIds }: DeleteParams) => {
      dispatch(streamActions.deleteStream({ kind, streamId, destinationIds, hasWebinar }));

      canDeleteFile && projectId && dispatch(videoFolderActions.deleteProject(projectId));
    },
    [uploadId, projectId, kind, hasWebinar]
  );

  const fetchUploadProjects = useCallback(() => {
    uploadId && dispatch(uploadsActions.getUploadProjects(uploadId));
  }, [uploadId]);

  return [isDeletePending, handleDeleteStream, uploadProjects, fetchUploadProjects] as const;
};

export default useDeleteStream;
